import axios from "axios";

const state = {
  emailTemplates: [],
  listEmailTemplates: [],
  listIdNameEmailTemplates: null,
  listSampleEmailTemplates: [],
  applicationFormSubmissionUserEmailTemplate: {
    subject: `Form Submission Summary - {2}`,
    message: `Dear {0} {1}<br/><br/>
    Thank you for your form submission to {2}, please find the details of your submission below:
    <br/>{3}<br/>
    `,
    isHtml: true
  },
  profileSectionFormSubmissionEmailTemplate: {
    subject: `Section {0} of a {1} is {8}`,
    message: `Section {0} of the {1}: {2} {3} is {8}<br/>
      Email Address: {4}<br/>
      Details of the submission:
      <br/>{7}<br/>
      Please log into the administrator dashboard ({6}/login/{5}) to view it!
      `
  },
  profileSectionWithDialogAddedEmailTemplate: {
    subject: `{0} {1} added a new item in the {2} section`,
    message: `{0} {1} added a new item in the {2} section
      Title: {3}
      Please log into the administrator dashboard ({5}/login/{4}) to view it!
      `
  },
  profileSectionWithDialogUpdatedEmailTemplate: {
    subject: `{0} {1} updated an item in the {2} section`,
    message: `{0} {1} updated an item in the {2} section
      Title: {3}
      Please log into the administrator dashboard ({5}/login/{4}) to view it!
      `
  },
  jobAssignedEmployerNotificationEmailTemplate: {
    subject: `You're All Set! Care Request for {0} Confirmed`,
    message:
      `Hello {1},` +
      "<br/><br/>" +
      `{2} {3} has been scheduled to care for your family on {0}.<br/>` +
      `To learn more about {2} or to view additional booking details please log into your dashboard and click on your service request: ({4})<br/><br/>` +
      "In the meantime, we are here for you if you need anything else!<br/><br/>" +
      "With Care,<br/>" +
      `The {5} Team`
  },
  jobAssignedAdminNotificationEmailTemplate: {
    subject: `Client {0} {1} {8} shift job on {6} {7} for candidate {3} {4}`,
    message:
      `Hello,` +
      "<br/><br/>" +
      "The client {0} {1} ({2}) {8} shift job on {6} {7} for candidate {3} {4} ({5})"
  },
  jobAcceptedAdminNotificationEmailTemplate: {
    subject: `Job for {0} on {1} accepted by {2}`,
    message:
      "<p>Hello,</p>" +
      "<p></p>" +
      `<p>A job has been filled!</p>` +
      `<p>Client: {0}</p>` +
      `<p>Details: {1}, {5} - {6}</p>` +
      `<p>Candidate: {2} {3}, {4}</p>`
  },
  jobInterestedAdminNotificationEmailTemplate: {
    subject: `Job for [[clientfname]] [[clientlname]] on [[date]] marked as "[[status]]" by [[candidatefname]] [[candidatelname]]`,
    message: "Hello, <br/><br/>" +
      "A job has been marked as [[statusLowerCase]] <br/><br/>" +
      "Client: [[clientfname]] [[clientlname]]<br/><br/>" +
      "Details: [[date]], [[starttime]] - [[endtime]] <br/><br/>" +
      "Candidate: [[candidatefname]] [[candidatelname]], [[candidateemail]]  <br/><br/>" +
      "Message: [[applicationNotes]] <br/><br/>" +
      "Job ID: [[jobid]]"
  },
  jobCandidateReminderEmailTemplate: {
    subject: `Job starts in [[notifyhours]] hours`,
    message: "Dear [[candidatefname]], <br/><br/>" +
      "You have an assigned job, which will start in [[notifyhours]] hours.<br/>" +
      "Job information<br/>" +
      "Poster: [[clientfname]] [[clientlname]]<br/>" +
      "Date: [[date]]<br/>" +
      "Time: [[starttime]]-[[endtime]]"
  },
  jobClientReminderEmailTemplate: {
    subject: `Job starts in [[notifyhours]] hours`,
    message: "Dear [[clientfname]], <br/><br/>" +
      "You have a posted job, which will start in [[notifyhours]] hours.<br/>" +
      "Job information<br/>" +
      "Candidate: [[candidatefname]] [[candidatelname]]<br/>" +
      "Date: [[date]]<br/>" +
      "Time: [[starttime]]-[[endtime]]"
  },
  jobClockInReminderEmailTemplate: {
    subject: `Clock In Reminder`,
    message: "Dear [[candidatefname]], <br/><br/>" +
      "Please clock in for the job<br/>" +
      "Poster: [[clientfname]] [[clientlname]]<br/>" +
      "Date: [[date]]<br/>" +
      "Time: [[starttime]]-[[endtime]]"
  },
  jobClockOutReminderEmailTemplate: {
    subject: `Clock Out Reminder`,
    message: "Dear [[candidatefname]], <br/><br/>" +
      "Please clock out for the job<br/>" +
      "Poster: [[clientfname]] [[clientlname]]<br/>" +
      "Date: [[date]]<br/>" +
      "Time: [[starttime]]-[[endtime]]"
  },
  applicationSubmittedShiftJobAdminNotificationEmailTemplate: {
    subject: "Job {0} - {5} ({8})",
    message: `<p>Hello,</p>
    <p></p>
    <p>New application submitted.</p>
    <p>Client: {1}</p>
    <p>Details: {2}, {3} - {4}</p>
    <p>Candidate: {5} {6}, {7}</p>
    <p>Status: {8}</p>
    <p>Message: {9}</p>
    <p>Job ID: {10}</p>
    <p>Job Link: {11}</p>
    `
  },
  applicationSubmittedPlacementJobAdminNotificationEmailTemplate: {
    subject: "Job {0} - {3} ({6})",
    message: `<p>Hello,</p>
    <p></p>
    <p>New application submitted.</p>
    <p>Job: {0} ({1}, {2})</p>
    <p>Candidate: {3} {4}, {5}</p>
    <p>Status: {6}</p>
    <p>Message: {7}</p>
    <p>Job ID: {8}</p>
    <p>Job Link: {9}</p>
    `
  },
  nannyAssignedEmployerNotificationEmailTemplate: {
    subject: `Candidate Assigned for {0}`,
    message:
      `Hello {1},` +
      "<br/><br/>" +
      `{2} {3} has been assigned to your service request on {0}.<br/>` +
      `To view more details about them, please log into your dashboard ({6}/login/{4}) and click on your service request.<br/><br/>` +
      "Please don't hesitate to reach out if you have any questions or issues!<br/><br/>" +
      "Thank you,<br/>" +
      `{5} Team`
  },
  nannyAssignedCandidateNotificationEmailTemplate: {
    subject: `Job Assigned for {0}`,
    message:
      `Hello {1},` +
      "<br/><br/>" +
      `You have been assigned to a job on {0}.<br/>` +
      `To view more details about the job, please log into your dashboard ({2}/login/{3}) and click on the "My Jobs" tab.<br/><br/>` +
      "Please don't hesitate to reach out if you have any questions or issues!<br/><br/>" +
      "Thank you,<br/>" +
      `{4} Team`
  },
  jobBookingAddedAgencyNotificationEmailTemplate: {
    subject: "New Booking - {1} {2} {0}",
    message:
      "The client {1} {2} ({3}) has just made a new booking request for {0} {4} - {5}.\n{6}\n\n" +
      "{7}"
  },
  jobBookingAddedWithMultipleDaysAgencyNotificationEmailTemplate: {
    subject: "New Bookings - {0} {1}",
    message:
      "The client {0} {1} ({2}) has just made new booking requests for the following days:\n\n{3}\n\n" +
      "Please go to the shift job calendar to view all of the details."
  },
  bookingGroupCreatedAgencyNotificationEmailTemplate: {
    subject: "New Booking Group of {1} {2}",
    message:
      "The client {1} {2} ({3}) has just created a new booking group of the following jobs:\n{0}.\n\n" +
      "Please go to the shift job calendar to view all of the details."
  },
  jobBookingUpdatedAgencyNotificationEmailTemplate: {
    subject: "Booking updated - {1} {2} {0}",
    message:
      "The client {1} {2} ({3}) has just updated the booking request for {0} {4} - {5}.\n\n" +
      "Detail update:\n{6}\n\n" +
      "Please go to the shift job calendar to view all of the details."
  },
  jobBookingUpdatedFillerNotificationEmailTemplate: {
    subject: "Booking updated - {1} {2} {0}",
    message:
      "The client {1} {2} ({3}) has just updated the booking request for {0} {4} - {5}.\n\n" +
      "Detail update:\n{6}\n\n"
  },
  jobBookingCancelledAgencyNotificationEmailTemplate: {
    subject: "Booking cancelled - {1} {2} {0}",
    message:
      "The client {1} {2} ({3}) has just cancelled the booking request for {0} {4} - {5}{7}.\n\n{8}" +
      "The client's reason for canceling is: \n {6}\n\n" +
      "Please go to the shift job calendar to view all of the details."
  },
  jobBookingCancelledFillerNotificationEmailTemplate: {
    subject: "Booking cancelled - {1} {2} {0}",
    message:
      "The client {1} {2} ({3}) has just cancelled the booking request for {0} {4} - {5}.\n{6}\n"
  },
  createdRelationshipNotificationEmailTemplate: {
    subject: `New candidate for you to consider - {0}`,
    message:
      `Hello {1},` +
      "<br/><br/>" +
      `We have found a great new candidate for you to consider: {0}!<br/>` +
      `Please log into your dashboard ({4}/login/{2}) to view their profile and let us know what you think.<br/><br/>` +
      `Thanks!<br/>` +
      `{3}`
  },
  bulkCreatedRelationshipsNotificationEmailTemplate: {
    subject: `New candidates for you to consider - {0}`,
    message:
      `Hello {1},` +
      "<br/><br/>" +
      `We have found a great new candidates for you to consider: {0}!<br/>` +
      `Please log into your dashboard ({4}/login/{2}) to view their profile and let us know what you think.<br/><br/>` +
      `Thanks!<br/>` +
      `{3}`
  },
  updatedRelationshipNotificationEmailTemplate: {
    subject: `New candidate for you to consider - {0}`,
    message:
      `Hello {1},` +
      "<br/><br/>" +
      `We have found a great new candidate for you to consider: {0}!<br/>` +
      `Please log into your dashboard ({4}/login/{2}) to view their profile and let us know what you think.<br/><br/>` +
      `Sincerely,<br/>{3}`
  },
  scheduleEventNotificationEmailTemplate: {
    subject: `Event Scheduled - [[title]], [[date]], [[time]]`,
    message:
      `Hi [[fname]], <br/><br/>` +
      `You have a new event scheduled: [[title]] \n` +
      `Date: [[date]] <br/>` +
      `Time: [[time]] <br/>` +
      `Link: [[scheduling_link]] <br/>` +
      `Notes: [[notes]] <br/><br/>` +
      `You can view this event in your dashboard as well ([[root_url]]/login/[[agency_id]]). Please let us know if you have any questions! <br/><br/>` +
      `Thanks, <br/>` +
      `[[agency_name]]`
  },
  referenceCheckFormEmailTemplate: {
    subject: "Reference Check For {0} {1}",
    message: `Hi {2} {3} <br/><br/>
    Please fill the form {4} to give us the reference check information about {0} {1}<br/>
    Sincerely,<br/>{5}
    `
  },
  shiftJobBroadcastEmailTemplate: {
    subject: "New shift available on [[date]], [[starttime]] - [[endtime]]",
    message: `Hi [[fname]],<br/><br/>
    There is a new shift available on [[date]] from [[starttime]] to [[endtime]]<br/>
    If you are interested please go to [[joblink]] for more details.<br/><br/>
    Thanks!`
  },
  shiftJobBulkBroadcastEmailTemplate: {
    subject: "New Bookings to review",
    message: "[[candidatefname]], <br/><br/>" +
      "We have new jobs for you to review: <br/>" +
      "[[linkstojobs]] <br/><br/>" +
      'To Review more information about these jobs, please log into your profile and review them under "Available Jobs". <br/>' +
      "Thank you."
  },
  placementJobBroadcastEmailTemplate: {
    subject: "New Opportunity - {0}",
    message:
      "<p>Hi [[fname]],</p>" +
      "<p></p>" +
      `<p>There is a new opportunity available that may be of interest to you, to see all of the details please visit: {3}/job/{2}/{1}</p>`
  },
  placementJobBulkBroadcastEmailTemplate: {
    subject: "New Jobs to review",
    message: "[[candidatefname]], <br/><br/>" +
      "We have new jobs for you to review: <br/>" +
      "[[linkstojobs]] <br/><br/><br/>" +
      'To Review more information about these jobs, please log into your profile and review them under "Available Jobs". <br/>' +
      "Thank you."
  },
  shareClientProfileNotificationEmailTemplate: {
    subject: `New client profile shared with you - {0}`,
    message:
      `Hello {1},` +
      "<br/><br/>" +
      `There is a new client profile shared with you: {0}!<br/>` +
      `Please log into your dashboard ({4}/login/{2}) to view the profile and let us know what you think.<br/><br/>` +
      `Thanks!<br/>` +
      `{3}`
  },
  clientInterestedPreliminaryAgencyNotificationEmailTemplate: {
    subject: `Client {0} Interested in {1}`,
    message:
      "Hello {2}," +
      "\n\n" +
      `The client {0} is interested in the candidate {1}!\n` +
      `They should submit the follow up form shortly!\n\n` +
      `Cheers!`
  },
  clientInterestedAgencyNotificationEmailTemplate: {
    subject: `Client {0} Interested in {1}`,
    message:
      "Hello {4}," +
      "\n\n" +
      `The client {0} is interested in the candidate {1}!\n` +
      `Client meeting preference: {2}\n` +
      `Client availability: {3}\n\n` +
      `Cheers!`
  },
  clientNotInterestedAgencyNotificationEmailTemplate: {
    subject: `Client {0} NOT Interested in {1}`,
    message:
      "Hello {2}," +
      "\n\n" +
      `The client {0} is NOT interested in the candidate {1}!\n`
  },
  clientNotInterestedFeedbackAgencyNotificationEmailTemplate: {
    subject: `Client {0} NOT Interested in {1}`,
    message:
      "Hello {2}," +
      "\n\n" +
      `The client {0} is NOT interested in the candidate {1}!\n` +
      `Feedback: {3}\n`
  },
  clientExtendedOfferAgencyNotificationEmailTemplate: {
    subject: `Client {0} extended offer to {1}`,
    message:
      "Hello," +
      "\n\n" +
      `The client {0} has extended an offer to the candidate {1}!\n` +
      `Detail Offer:\n{2}\n` +
      `Cheers!`
  },
  candidateInterestedAgencyNotificationEmailTemplate: {
    subject: `Candidate {0} Interested in {1}`,
    message:
      "Hello," +
      "\n\n" +
      `The candidate {0} is interested in the client {1}!\n` +
      `Cheers!`
  },
  candidateNotInterestedAgencyNotificationEmailTemplate: {
    subject: `Candidate {0} NOT Interested in {1}`,
    message:
      "Hello," +
      "\n\n" +
      `The candidate {0} is NOT interested in the client {1}!\n`
  },
  feedbackCandidateNotInterestedAgencyNotificationEmailTemplate: {
    subject: `Candidate Feedback - {0} NOT Interested in {1}`,
    message:
      "Hello," +
      "\n\n" +
      `The candidate {0} is NOT interested in the client {1}!\n`
      + 'Feedback:\n{2}'
  },
  reviewSubmittedAgencyNotificationEmailTemplate: {
    subject: `New Review from {0} for {1}`,
    message: `New Review from {0} for {1}\n` + `Text: {2}\n` + `Rating: {3} \n`
  },
  shiftJobAcceptedCandidateNotificationEmailTemplate: {
    subject: `You have accepted a shift for the {0} {1} family`,
    message: `Hi {2},
You have accepted a shift for the {0} {1} family on {3} from {4} to {5}. All of the details are in your dashboard under "My Jobs".
Please let us know ASAP if you have any questions or concerns!
Sincerely,
{6}`
  },
  shiftJobAcceptedClientNotificationEmailTemplate: {
    subject: `Your request has been accepted`,
    message: `Hi {0},
Your request on {2} from {3} to {4} has been accepted by {1}! To view a bit for information, please click on the booking in the booking calendar in your family dashboard. Please don't forget to leave a review afterwards!
Please let us know if you have any questions or concerns.
Sincerely,
{5}`
  },
  packageSelectedNotificationEmailTemplate: {
    subject: `Package Selected - {0} {1} | {2}`,
    message:
      "Hello," +
      "\n\n" +
      `{0} {1} just selected the following package: {2}\n\n` +
      "Cheers!"
  },
  timeOffRequestNotificationEmailTemplate: {
    subject: "New time off request - {0} {1}",
    message:
      "New time off request from {0} {1}\n\n" +
      "Please log into the admin dashboard ({2}/login/{3}) to view it!"
  },
  paymentSubmittedEmailNotification: {
    subject: "Payment Submitted - [[fname]] [[lname]]",
    message: `Hello <br/><br/>
    [[fname]] [[lname]] ([[email]]) has just submitted payment information.
    `
  },
  creditCardInfoUpdatedEmailNotification: {
    subject: "Credit Card Info Updated - {0} {1}",
    message: "Hello \n\n" +
      "Client {0} {1} ({2}) updated credit card information."
  },
  referenceCheckFormSubmitedAdminNotification: {
    subject: "Reference Check Form Submitted for [[fname]] [[lname]] by [[ref_fname]] [[ref_lname]]",
    message: "Hello,<br/><br/>" +
      "Reference Check Form Submitted for [[fname]] [[lname]] ([[email]]) by [[ref_fname]] [[ref_lname]]<br/>" +
      "Application Details:<br/>" +
      "[[application_content]]"
  },
  bookingOnBlockedDateAdminNotification: {
    subject: "{0} {1} tried to book full date {2}",
    message: "{0} {1} ({3}) tried to book full date {2}<br/>" + "{4}"
  },
  assignedAsManagerAdminNotification: {
    subject:
      "[[agfname]] [[aglname]] assigned you to manage [[fname]] [[lname]]",
    message: `[[agfname]] [[aglname]] assigned you to manage [[fname]] [[lname]]\n[[userType]] Email: [[email]]`
  },
  adminNoteNotificationDefaultEmailTemplate: {
    subject: `{0} {1} tagged you in a note for {2}`,
    message:
      `{5}{0} {1} tagged you in a note for {2} <br/><br/>{3}<br/><br/>` +
      `Please click at the link to view: <a href="{4}">{4}</a>`
  },
  candidateDeclineJobAdminNotification: {
    subject: "Candidate {0} {1} declined the shift job on {6} {7}-{8}",
    message: "Candidate {0} {1} ({2}) declined the shift job on {6} {7}-{8} of the client {3} {4} ({5})"
  },
  candidateDeclineJobClientNotification: {
    subject: "Candidate {0} {1} declined your shift job",
    message: "Candidate {0} {1} declined your shift job on {2} {3}-{4}"
  },
  scheduleReleaseClientNotificationEmailTemplate: {
    subject: "Schedule For this Week",
    message: "Hi {0}<br/>" + "Here is your schedule for this week!<br/><br/>{1}<br/><br/>" +
      "Please log into your dashboard at {4}/login/{2} to view all of the details!<br/>"
      + `The {3} Team`
  },
  scheduleReleaseCandidateNotificationEmailTemplate: {
    subject: "Schedule For this Week",
    message: "Hi {0}<br/>" + "Here is your schedule for this week!<br/><br/>{1}<br/><br/>" +
      "Please log into your dashboard at {4}/login/{2} to view all of the details!<br/>"
      + `The {3} Team`
  },
  notifyClientOnAssigningCandidateToMultipleJobs: {
    subject: "Requests Filled",
    message: "Hi {0}\n\n{1} {2} has been assigned to your service request(s) on {3}\n" +
      `To view more details about them, please log into your dashboard at <a href="{4}/login/{5}">{4}/login/{5}</a> and click on your service request. \n\n` +
      "Please don't hesitate to reach out if you have any questions or issues! \n\nThank you, \n{6} Team"
  },
  notifyCandidateOnAssigningToMultipleJobs: {
    subject: "Jobs Assigned",
    message: "Hi {0}\n\nYou have been assigned to jobs on {1}\n" +
      `To view more details about the job, please log into your dashboard at <a href="{2}/login/{3}">{2}/login/{3}</a> and click on the "My Jobs" tab. \n\n` +
      "Please don't hesitate to reach out if you have any questions or issues! \n\nThank you, \n{4} Team"
  },
  applicationDeclinedCandidateNotificationEmailTemplate: {
    subject: `Shift Application Declined for [[date]], [[starttime]] - [[endtime]], [[clientfname]], [[jobtitle]]`,
    message:
      "Hi [[candidatefname]], <br /><br/>" +
      "Your application for the following shift was declined: <br/>" +
      "Date: [[date]] <br/>" +
      "Start Time: [[starttime]] <br/>" +
      "End Time: [[endtime]] <br/>" +
      "Type: [[jobtitle]] <br/>" +
      "Client: [[clientfname]] <br/>" +
      "Please reach out to the scheduling dept if you have any questions! <br/>" +
      "Thanks! <br/><br/>" +
      "The [[agencyName]] Team",
  },
  addedNewAdminNotification: {
    subject: "New Administrator Added to {0}",
    message: `A new admin is added to {0}\nAgency ID: {1}\nAdmin Name: {2}\nAdmin Email: {3}`
  },
  resourceIsViewedNotificationEmailTemplate: {
    subject: "Resource {0} Viewed",
    message: `Resource {0} is viewed by user {1} (<a href="mailto:{2}">{2}</a>)`
  },
  markedAsNotificationEmailTemplate: {
    subject: `Marked as {0}`,
    message: `{1} marked {2} as {0}.`
  },
  clientPostNewPlacementJobEmailTemplate: {
    subject: `A new job is posted.`,
    message: `
      Job Title: {0}
      Job poster: {1} {2}
      Status: {3}
      Job Type: "Long Term"
    `
  },
  topicDeletedEmailTemplate: {
    subject: `Topic Deleted`,
    message: `A topic has been deleted`
  },
  commentAddedEmailTemplate: {
    subject: `New Comment Added`,
    message: `
    A new comment has been added:<br><br>
    Click on the link below to view the comment <br> {0}`
  },
  commentUpdatedEmailTemplate: {
    subject: `Comment Updated`,
    message: `
    A comment has been updated:<br><br>
    Click on the link below to view the updated comment <br> {0}`
  },
  commentDeletedEmailTemplate: {
    subject: `Comment Deleted`,
    message: `A comment has been deleted`
  },
  timeOffRequestDeclinedEmailTemplate: {
    subject: `Time Off Request Has Been DECLINED`,
    message: `Your time off request for {0} has been declined. \n\nNote: {1}`
  },
  timeOffRequestApprovedEmailTemplate: {
    subject: `Your Time Off Request Has Been Approved`,
    message: `Your Time Off Request for {0} Has Been Approved!` + '\n\n'
  },
  notifyClientWhenAssignedCandidateEmailTemplate: {
    subject: `New candidate for you to consider - [[candidatefname]] [[candidatelname]]`,
    message:
      `Hello [[fname]],<br/><br/>` +
      `We have found a great new candidate for you to consider: [[candidatefname]] [[candidatelname]]!<br/>` +
      `Please log into your dashboard ({0}/login/{1}) to view their profile and let us know what you think.<br/><br/>` +
      `Thanks!<br/>` +
      `{2}`
  },
  notifyClientOnBulkAssignEmailTemplate: {
    subject: "Requests Filled",
    message: "Hi [[clientfname]]<br/><br/>[[candidatefname]] [[candidatelname]] has been assigned to your service request(s) on [[jobdates]]<br/>" +
      `To view more details about them, please log into your dashboard at <a href="{0}/login/{1}">{0}/login/{1}</a> and click on your service request. <br/><br/>` +
      "Please don't hesitate to reach out if you have any questions or issues! <br/><br/>Thank you, <br/>[[agencyName]] Team"
  },
  notifyCandidateOnBulkAssignEmailTemplate: {
    subject: "Jobs Assigned",
    message: "Hi [[candidatefname]]<br/><br/>You have been assigned to jobs on [[jobdates]]<br/>" +
      `To view more details about the job, please log into your dashboard at <a href="{0}/login/{1}">{0}/login/{1}</a> and click on the "My Jobs" tab. <br/><br/>` +
      "Please don't hesitate to reach out if you have any questions or issues! <br/><br/>Thank you, <br/>[[agencyName]] Team"
  },
  reportProblemEmailTemplate: {
    subject: "{0} - {1}",
    message: `The candidate {1} (ID: {2}) clicked the {0} button of the shift job on {5} (ID: {6} - Poster {7})<br/>
    <b>{3}:</b><br/> {4}`
  },
  clientReportProblemEmailTemplate: {
    subject: "{0} - {1}",
    message: `The client {1} (ID: {2}) clicked the {0} button of the shift job on {5} (ID: {6})<br/>
    <b>{3}:</b><br/> {4}`
  },
  candidateChangeRecurringAvailabilityEmailTemplate: {
    subject: `Candidate Schedule Updated`,
    message: `Candidate {0} {1} has {2} Recurring Availability`
  },
  defaultShiftJobReportClientNotificationEmailTemplate: {
    subject: `[[candidatefname]] [[candidatelname]] submitted a shift job report for your job on [[date]]`,
    message: `
            Dear [[clientfname]]<br/><br/>
            [[candidatefname]] [[candidatelname]] submitted a shift job report for your job on [[date]]<br/>
            Shift Job Report Details:
            <br/>[[report_detail]]<br/>
        `
  },
  clientAddedNoteAssignedCandidateEmailTemplate: {
    subject: "New Note added to an assigned candidate",
    message: `The client {0} (ID: {1}) has added a note for the candidate {2} (ID: {3})<br/>
    Note: {4}`
  },
  userClickGuideNotificationEmailTemplate: {
    subject: "{2} {0} from {1} viewed today’s activity guide!",
    message: `Agency ID: {2}<br/>
    Agency Name: {1}<br/>
    User ID: {3}<br/>
    Name: {4} {5}<br/>
    Email: {0}
    `
  },
  dailyGuideFeedbackEmailTemplate: {
    subject: "{2} Feedback for today’s activity guide! from {0} of {1}",
    message: `Agency ID: {2}<br/>
    Agency Name: {1}<br/>
    User ID: {3}<br/>
    Name: {4} {5}<br/>
    Email: {0}<br/>
    Template: {6}<br/>
    Feedback: {7}
    `
  },
  userClickBenefitNotificationEmailTemplate: {
    subject: "Benefit: {0}, {1}: {2}",
    message: `Agency ID: {2}<br/>
    Agency Name: {1}<br/>
    User ID: {3}<br/>
    Name: {4} {5}<br/>
    Email: {0}<br/>
    Benefit: {6} (ID: {7})
    `
  },

  userClickNotInterestedBenefitNotificationEmailTemplate: {
    subject: "Not Interested in Benefit: {0}, {1}: {2}",
    message: `Agency ID: {2}<br/>
    Agency Name: {1}<br/>
    User ID: {3}<br/>
    Name: {4} {5}<br/>
    Email: {0}<br/>
    Benefit: {6} (ID: {7})
    `
  },
  hideBenefitNotificationEmailTemplate: {
    subject: "Hide Benefit from agency: {0}, {1}: {2}",
    message: `Agency ID: {2}<br/>
    Agency Name: {1}<br/>
    User ID: {3}<br/>
    Name: {4} {5}<br/>
    Email: {0}<br/>
    Benefit: {6} (ID: {7})
    `
  },
  benefitFeedbackNotificationEmailTemplate: {
    subject: "Benefits feedback {0} {1}",
    message: `
    Feedback: {6}<br/>
    Agency ID: {2}<br/>
    Agency Name: {1}<br/>
    User ID: {3}<br/>
    Name: {4} {5}<br/>
    Email: {0}<br/>
    `
  },
  errorCalculatingPrice: {
    subject: "Error when calculating price {0}",
    message: `
    Agency ID: {0}<br/>
    User ID: {1}<br/>
    Expression: {2}<br/>
    Error: {3}
    `
  }
};

const mutations = {
  SET_EMAIL_TEMPLATES(state, tempaltes) {
    state.emailTemplates = tempaltes;
  },
  SET_ERRORS(state, error) {
    state.errors.push(error);
  },
  RESET_ERRORS(state) {
    state.errors = [];
  },
  setListEmailTemplates(state, payload) {
    state.listEmailTemplates = payload;
  },
  setListIdNameEmailTemplates(state, payload) {
    state.listIdNameEmailTemplates = payload;
  },
  setListSampleEmailTemplates(state, payload) {
    state.listSampleEmailTemplates = payload;
  },

};
const actions = {
  async fetchEmailTemplates({ commit, rootGetters }, { type, selector1 }) {
    return new Promise(async (resolve) => {
      const agencyID = rootGetters["agencyID"];
      const res = await axios.get(
        `/api/emailtemplates/?agency=${agencyID}&type=${type}&selector1=${selector1}`
      )
      if (res && res.data) {
        resolve(res.data);
        return;
      }
      resolve([]);
    });

  },
  setListEmailTemplates({ commit }, payload) {
    commit("setListEmailTemplates", payload);
  },
  setListIdNameEmailTemplates({ commit }, payload) {
    commit("setListIdNameEmailTemplates", payload);
  },
  setListSampleEmailTemplates({ commit }, payload) {
    commit("setListSampleEmailTemplates", payload);
  },
  getListEmailTemplates({ rootGetters, state, commit }) {
    return new Promise(async (resolve) => {
      if (state.listEmailTemplates && state.listEmailTemplates.length) {
        resolve(state.listEmailTemplates);
        return;
      }
      let res = await axios.get(
        `/api/emailtemplates/?agency=${rootGetters.agencyID}`
      );
      if (res && res.data) {
        commit('setListEmailTemplates', res.data);
        resolve(res.data);
        return;
      }
      commit('setListEmailTemplates', []);
      resolve([]);
    });
  },
  getListSampleEmailTemplates({ rootGetters, state, commit }, reload = false) {
    return new Promise(async (resolve) => {
      if (!reload && state.listSampleEmailTemplates && state.listSampleEmailTemplates.length) {
        resolve(state.listSampleEmailTemplates);
        return;
      }
      let res = await axios.get(
        `/api/sampleemailtemplates/`
      );
      if (res && res.data) {
        commit('setListSampleEmailTemplates', res.data);
        resolve(res.data);
        return;
      }
      commit('setListSampleEmailTemplates', []);
      resolve([]);
    });
  },
  getListIdNameEmailTemplates({ rootGetters, state, getters, commit }) {
    return new Promise(async (resolve) => {
      if (state.listIdNameEmailTemplates) {
        resolve(state.listIdNameEmailTemplates);
        return;
      }
      let res = await axios.get(
        `/api/emailtemplates/?agency=${rootGetters.agencyID}&id_name=true`
      );
      if (res && res.data) {
        commit('setListIdNameEmailTemplates', res.data);
        resolve(res.data);
        return;
      }
      commit('setListIdNameEmailTemplates', null);
      resolve(null);
    });
  },
};

const getters = {
  listEmailTemplates(state) {
    return state.listEmailTemplates;
  },
  listIdNameEmailTemplates(state) {
    if (state.listEmailTemplates && state.listEmailTemplates.length) {
      return state.listEmailTemplates;
    }
    return state.listIdNameEmailTemplates || [];
  },
  listSampleEmailTemplates(state) {
    return state.listSampleEmailTemplates;
  },
  addedNewAdminNotification: state => state.addedNewAdminNotification,
  topicDeletedEmailTemplate: state => state.topicDeletedEmailTemplate,
  commentAddedEmailTemplate: state => state.commentAddedEmailTemplate,
  commentUpdatedEmailTemplate: state => state.commentUpdatedEmailTemplate,
  commentDeletedEmailTemplate: state => state.commentDeletedEmailTemplate,
  clientNotInterestedFeedbackAgencyNotificationEmailTemplate: state => state.clientNotInterestedFeedbackAgencyNotificationEmailTemplate,
  emailTemplates: state => state.emailTemplates,
  notifyClientOnAssigningCandidateToMultipleJobs: state => state.notifyClientOnAssigningCandidateToMultipleJobs,
  notifyCandidateOnAssigningToMultipleJobs: state => state.notifyCandidateOnAssigningToMultipleJobs,
  resourceIsViewedNotificationEmailTemplate: state => state.resourceIsViewedNotificationEmailTemplate,
  markedAsNotificationEmailTemplate: state => state.markedAsNotificationEmailTemplate,
  shiftJobBulkBroadcastEmailTemplate: state => state.shiftJobBulkBroadcastEmailTemplate,
  placementJobBulkBroadcastEmailTemplate: state => state.placementJobBulkBroadcastEmailTemplate,
  jobInterestedAdminNotificationEmailTemplate: state => state.jobInterestedAdminNotificationEmailTemplate,
  jobCandidateReminderEmailTemplate: state => state.jobCandidateReminderEmailTemplate,
  jobClockInReminderEmailTemplate: state => state.jobClockInReminderEmailTemplate,
  jobClockOutReminderEmailTemplate: state => state.jobClockOutReminderEmailTemplate,
  jobClientReminderEmailTemplate: state => state.jobClientReminderEmailTemplate,
  applicationSubmittedShiftJobAdminNotificationEmailTemplate(state) {
    return state.applicationSubmittedShiftJobAdminNotificationEmailTemplate;
  },
  applicationSubmittedPlacementJobAdminNotificationEmailTemplate(state) {
    return state.applicationSubmittedPlacementJobAdminNotificationEmailTemplate;
  },
  applicationFormSubmissionAdminEmailTemplate(state) {
    return state.applicationFormSubmissionAdminEmailTemplate;
  },
  applicationFormSubmissionUserEmailTemplate(state) {
    return state.applicationFormSubmissionUserEmailTemplate;
  },
  profileSectionFormSubmissionEmailTemplate(state) {
    return state.profileSectionFormSubmissionEmailTemplate;
  },
  profileSectionWithDialogAddedEmailTemplate(state) {
    return state.profileSectionWithDialogAddedEmailTemplate;
  },
  profileSectionWithDialogUpdatedEmailTemplate(state) {
    return state.profileSectionWithDialogUpdatedEmailTemplate;
  },
  jobAssignedEmployerNotificationEmailTemplate(state) {
    return state.jobAssignedEmployerNotificationEmailTemplate;
  },
  jobAssignedAdminNotificationEmailTemplate(state) {
    return state.jobAssignedAdminNotificationEmailTemplate;
  },
  jobAcceptedAdminNotificationEmailTemplate(state) {
    return state.jobAcceptedAdminNotificationEmailTemplate;
  },
  nannyAssignedEmployerNotificationEmailTemplate(state) {
    return state.nannyAssignedEmployerNotificationEmailTemplate;
  },
  nannyAssignedCandidateNotificationEmailTemplate(state) {
    return state.nannyAssignedCandidateNotificationEmailTemplate;
  },
  jobBookingAddedAgencyNotificationEmailTemplate(state) {
    return state.jobBookingAddedAgencyNotificationEmailTemplate;
  },
  jobBookingAddedWithMultipleDaysAgencyNotificationEmailTemplate(state) {
    return state.jobBookingAddedWithMultipleDaysAgencyNotificationEmailTemplate;
  },
  bookingGroupCreatedAgencyNotificationEmailTemplate(state) {
    return state.bookingGroupCreatedAgencyNotificationEmailTemplate;
  },
  jobBookingUpdatedAgencyNotificationEmailTemplate(state) {
    return state.jobBookingUpdatedAgencyNotificationEmailTemplate;
  },
  jobBookingUpdatedFillerNotificationEmailTemplate(state) {
    return state.jobBookingUpdatedFillerNotificationEmailTemplate;
  },
  jobBookingCancelledAgencyNotificationEmailTemplate(state) {
    return state.jobBookingCancelledAgencyNotificationEmailTemplate;
  },
  jobBookingCancelledFillerNotificationEmailTemplate(state) {
    return state.jobBookingCancelledFillerNotificationEmailTemplate;
  },
  createdRelationshipNotificationEmailTemplate(state) {
    return state.createdRelationshipNotificationEmailTemplate;
  },
  bulkCreatedRelationshipsNotificationEmailTemplate(state) {
    return state.bulkCreatedRelationshipsNotificationEmailTemplate;
  },
  updatedRelationshipNotificationEmailTemplate(state) {
    return state.updatedRelationshipNotificationEmailTemplate;
  },
  scheduleEventNotificationEmailTemplate(state) {
    return state.scheduleEventNotificationEmailTemplate;
  },
  referenceCheckFormEmailTemplate(state) {
    return state.referenceCheckFormEmailTemplate;
  },
  shiftJobBroadcastEmailTemplate(state) {
    return state.shiftJobBroadcastEmailTemplate;
  },
  placementJobBroadcastEmailTemplate(state) {
    return state.placementJobBroadcastEmailTemplate;
  },
  shareClientProfileNotificationEmailTemplate(state) {
    return state.shareClientProfileNotificationEmailTemplate;
  },
  clientInterestedAgencyNotificationEmailTemplate(state) {
    return state.clientInterestedAgencyNotificationEmailTemplate;
  },
  clientInterestedPreliminaryAgencyNotificationEmailTemplate(state) {
    return state.clientInterestedPreliminaryAgencyNotificationEmailTemplate;
  },
  clientNotInterestedAgencyNotificationEmailTemplate(state) {
    return state.clientNotInterestedAgencyNotificationEmailTemplate;
  },
  candidateInterestedAgencyNotificationEmailTemplate(state) {
    return state.candidateInterestedAgencyNotificationEmailTemplate;
  },
  candidateNotInterestedAgencyNotificationEmailTemplate(state) {
    return state.candidateNotInterestedAgencyNotificationEmailTemplate;
  },
  feedbackCandidateNotInterestedAgencyNotificationEmailTemplate(state) {
    return state.feedbackCandidateNotInterestedAgencyNotificationEmailTemplate;
  },
  clientExtendedOfferAgencyNotificationEmailTemplate(state) {
    return state.clientExtendedOfferAgencyNotificationEmailTemplate;
  },
  reviewSubmittedAgencyNotificationEmailTemplate(state) {
    return state.reviewSubmittedAgencyNotificationEmailTemplate;
  },
  shiftJobAcceptedCandidateNotificationEmailTemplate(state) {
    return state.shiftJobAcceptedCandidateNotificationEmailTemplate;
  },
  shiftJobAcceptedClientNotificationEmailTemplate(state) {
    return state.shiftJobAcceptedClientNotificationEmailTemplate;
  },
  packageSelectedNotificationEmailTemplate(state) {
    return state.packageSelectedNotificationEmailTemplate;
  },
  timeOffRequestNotificationEmailTemplate(state) {
    return state.timeOffRequestNotificationEmailTemplate;
  },
  paymentSubmittedEmailNotification(state) {
    return state.paymentSubmittedEmailNotification;
  },
  creditCardInfoUpdatedEmailNotification(state) {
    return state.creditCardInfoUpdatedEmailNotification;
  },
  referenceCheckFormSubmitedAdminNotification(state) {
    return state.referenceCheckFormSubmitedAdminNotification;
  },
  bookingOnBlockedDateAdminNotification(state) {
    return state.bookingOnBlockedDateAdminNotification;
  },
  assignedAsManagerAdminNotification(state) {
    return state.assignedAsManagerAdminNotification;
  },
  adminNoteNotificationDefaultEmailTemplate(state) {
    return state.adminNoteNotificationDefaultEmailTemplate;
  },
  candidateDeclineJobAdminNotification(state) {
    return state.candidateDeclineJobAdminNotification;
  },
  candidateDeclineJobClientNotification(state) {
    return state.candidateDeclineJobClientNotification;
  },
  scheduleReleaseClientNotificationEmailTemplate(state) {
    return state.scheduleReleaseClientNotificationEmailTemplate;
  },
  scheduleReleaseCandidateNotificationEmailTemplate(state) {
    return state.scheduleReleaseCandidateNotificationEmailTemplate;
  },
  applicationDeclinedCandidateNotificationEmailTemplate(state) {
    return state.applicationDeclinedCandidateNotificationEmailTemplate;
  },
  clientPostNewPlacementJobEmailTemplate(state) {
    return state.clientPostNewPlacementJobEmailTemplate;
  },
  timeOffRequestDeclinedEmailTemplate(state) {
    return state.timeOffRequestDeclinedEmailTemplate;
  },
  timeOffRequestApprovedEmailTemplate(state) {
    return state.timeOffRequestApprovedEmailTemplate;
  },
  notifyClientWhenAssignedCandidateEmailTemplate(state) {
    return state.notifyClientWhenAssignedCandidateEmailTemplate;
  },
  notifyCandidateOnBulkAssignEmailTemplate(state) {
    return state.notifyCandidateOnBulkAssignEmailTemplate;
  },
  notifyClientOnBulkAssignEmailTemplate(state) {
    return state.notifyClientOnBulkAssignEmailTemplate;
  },
  reportProblemEmailTemplate(state) {
    return state.reportProblemEmailTemplate;
  },
  candidateChangeRecurringAvailabilityEmailTemplate(state) {
    return state.candidateChangeRecurringAvailabilityEmailTemplate;
  },
  defaultShiftJobReportClientNotificationEmailTemplate(state) {
    return state.defaultShiftJobReportClientNotificationEmailTemplate;
  },
  clientAddedNoteAssignedCandidateEmailTemplate(state) {
    return state.clientAddedNoteAssignedCandidateEmailTemplate;
  },
  userClickGuideNotificationEmailTemplate(state) {
    return state.userClickGuideNotificationEmailTemplate;
  },
  dailyGuideFeedbackEmailTemplate(state) {
    return state.dailyGuideFeedbackEmailTemplate;
  },
  userClickBenefitNotificationEmailTemplate(state) {
    return state.userClickBenefitNotificationEmailTemplate;
  },
  userClickNotInterestedBenefitNotificationEmailTemplate(state) {
    return state.userClickNotInterestedBenefitNotificationEmailTemplate
  },
  hideBenefitNotificationEmailTemplate(state) {
    return state.hideBenefitNotificationEmailTemplate;
  },
  benefitFeedbackNotificationEmailTemplate(state) {
    return state.benefitFeedbackNotificationEmailTemplate;
  },
  errorCalculatingPrice(state) {
    return state.errorCalculatingPrice;
  }
};

export default {
  state,
  mutations,
  actions,
  getters
};



// WEBPACK FOOTER //
// ./src/store/modules/email-template.js